import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";

import DataTable from "../../components/Table/DataTable";
import SearchBox from "./../../components/SearchBox/SearchBox";

import { showAlert } from "../../store/ducks/alert";
import { getSubscribers } from "../../services/subscribers";
import { Button, CircularProgress } from "@material-ui/core";
import { useHistory } from 'react-router-dom';

const Subscribers = ({ location, match }) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [subscribers, setSubscribers] = useState([]);
  const [page, setPage] = useState(0)
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0);
  const [isLoading, setIsLoading] = useState(false);

  const [isSearching, setIsSearching] = useState(false);
  const [searchField, setSearchField] = useState({
    searchItem: '',
    search: '',
  });
  const [isOrdering, setIsOrdering] = useState(0);

  useEffect(() => {
    if (location.state && location.state.remount) {
      handleSubmitSearch({
        searchItem: '',
        search: '',
      });
    }
  }, [location]);


  useEffect(() => {
    if (match && match.params.searchItem && match.params.search) {
      handleSubmitSearch({
        searchItem: match.params.searchItem,
        search: match.params.search,
      });
    }
    handleGetSubscribers();
  }, [isSearching, isOrdering, page]);

  const handleSubmitSearch = searchBox => {
    setSearchField({
      ...searchField,
      searchItem: searchBox.searchItem,
      search: searchBox.search,
    });
    setIsSearching(searchBox.search);
  };

  const headers = ["email", "userId"];

  const handleGetSubscribers = async () => {
    try {
      setIsLoading(true);

      let params = {limit: 5}
      if(isSearching) params = {...searchField, ...params};

      const {data: subscribers} = await getSubscribers(page, params)

      setSubscribers(subscribers.rows);
      setTotalItems(subscribers.count);
      setTotalPages(subscribers.pages);
      setPage(subscribers.page);
      setIsLoading(false);
    } catch (error) {
      dispatch(showAlert("error", error.message));
    }
  };

  const handleGoToSubscribersDuplicated = () =>{
    history.push(`/subscribers/duplicated`)
  }

  if (isLoading)
    return <CircularProgress color="inherit" className="circular-progress" />;

  return (
    <>
      <div className="channels-container">
        <h1>Subscribers ({totalItems})</h1>
        <Button onClick={handleGoToSubscribersDuplicated} variant="contained" className="modal-btn">
        Subscriber Duplicated
        </Button>
        <SearchBox
          selectItems={['email', 'channelId']}
          onSubmitSearch={handleSubmitSearch}
          isSearching={isSearching}
        />
      </div>
      <DataTable
        useUid={true}
        head={headers}
        body={subscribers}
        action={true}
        bodyColumn={headers}
        linkPath={"subscribers"}
        totalPages={totalPages}
        currentPage={page}
        setPageChange={setPage}
        setIsOrdering={setIsOrdering}
      />
    </>
  );
};

export default Subscribers;
